module.exports = __webpack_public_path__ + "static/img/Reporting_system.3f75d2f4.png";